import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  CenteredMessage,
  getMessageForErrorCode,
  GraphQLErrorCode,
  isFatalError,
  reportGraphQLError,
} from '../../../data-catalog-shared';

export function renderNoData(): React.ReactNode {
  return <CenteredMessage message={Messages.ErrorNoData()} />;
}

export function renderError(errorCode: GraphQLErrorCode | null): React.ReactNode {
  return <CenteredMessage message={getMessageForErrorCode(errorCode)} />;
}

export function createRenderDataWithErrorFunction<TData>(
  renderData: (data: TData) => React.ReactNode
): (data: TData, errorCode: GraphQLErrorCode | null) => React.ReactNode {
  return (data: TData, errorCode: GraphQLErrorCode | null) => renderDataWithError(data, errorCode, renderData);
}

function renderDataWithError<TData>(
  data: TData,
  errorCode: GraphQLErrorCode | null,
  renderData: (data: TData) => React.ReactNode,
): React.ReactNode {
  if (errorCode) {
    if (isFatalError(errorCode)) {
      return renderError(errorCode);
    } else {
      return (
        <>
          {renderData(data)}
          {reportGraphQLError(errorCode)}
        </>
      );
    }
  } else {
    return (
      <>
        {renderData(data)}
        {reportGraphQLError(null)}
      </>
    );
  }
}
